export default __webpack_public_path__ + "static/media/mainlogo.af9c66b2.jpg";